
// import { getLocationHrefParam, inWeixin, urlencode } from '@/utils/cloud-utils'
import html2canvas from 'html2canvas'
import { OSSConfig } from '@/services/upload'
import SparkMD5 from 'spark-md5'
const OSS = require('ali-oss')
// 防抖
export function debounce(func, wait, immediate = true) {
  let timer = null;
  const _debounce = function (...args) {
    const context = this;
    if (timer) {
      clearTimeout(timer)
    }
    if (immediate) {
      if (!timer) { // null
        func.apply(this, args);
      }
      timer = setTimeout(() => {
        timer = null;
      }, wait)
    } else {
      timer = setTimeout(() => {
        func.apply(context, args);
        timer = null;
      }, wait)
    }
  }
  _debounce.cancel = function () {
    clearTimeout(timer);
    timer = null;
  }
  return _debounce;
}

// 节流
export function throttle(func, wait, options = {}) {
  let timer = null;

  const _throttle = function (...args) {
    const context = this;
    if (!timer) {
      timer = setTimeout(() => {
        func.apply(context, args);
        timer = null;
      }, wait)
    }
  }
  return _throttle;
}

// 微信登录
export function wxlogin(data, next) {
  next()
  // let code = getLocationHrefParam('code')
  // let codeNumber = getLocationHrefParam('codeNumber')
  // if (code) {
  //   getCodeByUserInfo({ code }).then(res => {
  //     if (res.code == 200) {
  //       sessionStorage.setItem("uid", res.data.memberId);
  //       sessionStorage.setItem("token", res.data.token);
  //       sessionStorage.setItem("openId", res.data.openid);

  //     } else if (res.code == 401) {
  //       sessionStorage.setItem("openId", res.data.openid);
  //       window.location.href = '/login?codeNumber=' + getLocationHrefParam(codeNumber)
  //     }
  //   })
  // } else {
  //   var appid = 'wxc5576ed047edb7f6'; // appid
  //   var url = urlencode(location.href.split("#")[0])
  //   var scope = 'snsapi_userinfo' // snsapi_base静默授权，snsapi_userinfo弹出授权页面
  //   var state = codeNumber; // 重定向带的参数
  //   window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
  //     appid + '&redirect_uri=' + url + '&response_type=code&scope=' + scope + '&state=' +
  //     state + '#wechat_redirect'
  // }
}

export function isEmail(value) {
  var pattern = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
  if (!pattern.test(value)) {
    return false;
  }
  return true;
}

export function isMobile(value) {
  var pattern = /^1[35789][0123456789]\d{8}$/;
  if (!pattern.test(value)) {
    return false;
  }
  return true;
}

export function phoneType() {
  // 判断手机类型
  var u = navigator.userAgent
  // var app = navigator.appVersion;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

  if (isAndroid) {
    return 1;
  }
  if (isIOS) {
    return 0;
  }
}

export function isNull(val) {
  if (val == 'null' || val == null || val == 'undefined' || val == undefined) {
    return true;
  } else {
    return false;
  }
}

export function closeShare() {
  // 禁用微信分享的功
  if (typeof WeixinJSBridge == 'undefined') {
    if (document.addEventListener) {
      // TODO: 下面的代码似乎有问题，进到这里 WeixinJSBridge 未定义，为什么还要调用 .call，下同
      // eslint-disable-next-line no-undef
      document.addEventListener('WeixinJSBridgeReady', WeixinJSBridge.call('hideOptionMenu'), false);
    } else if (document.attachEvent) {
      // eslint-disable-next-line no-undef
      document.attachEvent('WeixinJSBridgeReady', WeixinJSBridge.call('hideOptionMenu'));
      // eslint-disable-next-line no-undef
      document.attachEvent('onWeixinJSBridgeReady', WeixinJSBridge.call('hideOptionMenu'));
    }
  } else {
    // eslint-disable-next-line no-undef
    WeixinJSBridge.call('hideOptionMenu');
  }
}

export function htmlToFile(element, callback) {
  // eslint-disable-next-line no-unused-vars
  var abs = 0;
  var win_i = window.width; // 获得当前可视窗口的宽度（不包含滚动条）
  var win_o = window.innerWidth; // 获得当前窗口的宽度（包含滚动条）
  if (win_o > win_i) {
    abs = (win_o - win_i) / 2; // 获得滚动条长度的一半
  }
  const answer = element
  // var canvas = document.createElement('canvas');
  var w = answer ? answer.clientWidth : 100; // 获得该容器的宽
  // var h = answer.clientHeight;
  // var offsetTop = 0; // 获得该容器到文档顶部的距离
  // var offsetLeft = 0; // 获得该容器到文档最左的距离
  // canvas.width = w * 2; // 将画布宽&&高放大两倍
  // canvas.height = h * 2;
  // var context = canvas.getContext('2d');
  // context.scale(2, 2);
  // context.translate(-offsetLeft - abs, -offsetTop);
  // console.log(document.getElementsByClassName('right')[0].scrollHeight, document.getElementsByClassName('right')[0].offsetTop)
  html2canvas(answer, {
    useCORS: true,
    dpi: window.devicePixelRatio * 2,
    scale: 1,
    width: w,
    height: answer.scrollHeight,
    background: '#fff'
  }).then((canvas) => {
    canvas.toBlob((blobObj) => {
      // downloadImg(canvas)
      computedMD5(new window.File([blobObj], 'png'), callback)
      // callback(new window.File([blobObj], 'png'))
    })
  })
}

// 上传图片到OSS
export async function uploadImgToOss(file, fileMD5, callback) {
  let client, resOSS
  const fileType = file.name.split('.')[file.name.split('.').length - 1]
  const newData = new Date().getTime()
  if (sessionStorage.OSSExpire > newData) {
    const ossConfigData = JSON.parse(sessionStorage.OSSConfigData)
    client = new OSS({
      region: 'oss-cn-beijing',
      accessKeyId: ossConfigData.AccessKeyId,
      accessKeySecret: ossConfigData.AccessKeySecret,
      stsToken: ossConfigData.SecurityToken,
      bucket: 'growlib-glp-public',
      secure: true
    })
  } else {
    resOSS = await OSSConfig()
    client = new OSS({
      region: 'oss-cn-beijing',
      accessKeyId: resOSS.data.Credentials.AccessKeyId,
      accessKeySecret: resOSS.data.Credentials.AccessKeySecret,
      stsToken: resOSS.data.Credentials.SecurityToken,
      bucket: 'growlib-glp-public',
      secure: true
    })
    sessionStorage.OSSConfigData = JSON.stringify(resOSS.data.Credentials)
    sessionStorage.OSSExpire = new Date(resOSS.data.Credentials.Expiration).getTime()
  }
  const currentTime = new Date()
  let result = await client.put('bjesr/image/screenshot/' + currentTime.getFullYear() + (currentTime.getMonth() + 1) + currentTime.getDate() + '/' + fileMD5 + '.' + fileType, file);
  const url = result.res.requestUrls[0].split('?')[0]
  callback(url)
}
// 校验md5
export function computedMD5(file, callback) {
  const fileReader = new FileReader()
  fileReader.readAsArrayBuffer(file)
  fileReader.onload = async (e) => {
    const spark = new SparkMD5.ArrayBuffer()
    spark.append(e.target.result)
    const fileMD5 = spark.end()
    uploadImgToOss(file, fileMD5, callback)
  }
}

// 下载截图
// eslint-disable-next-line no-unused-vars
function downloadImg(canvas) {
  // const img = document.createElement('img');
  var imgDataSrc = canvas.toDataURL('image/png');
  // // img.src = imgDataSrc;
  // // document.body.appendChild(img);

  function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(',')
    var mime = arr[0].match(/:(.*?);/)[1]
    var bstr = atob(arr[1])
    var n = bstr.length
    var u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  function downloadFile(url, name = 'What\'s the fuvk') {
    var a = document.createElement('a')
    a.setAttribute('href', url)
    a.setAttribute('download', name)
    a.setAttribute('target', '_blank')
    let clickEvent = document.createEvent('MouseEvents');
    clickEvent.initEvent('click', true, true);
    a.dispatchEvent(clickEvent);
  }

  function downloadFileByBase64(base64, name) {
    var myBlob = dataURLtoBlob(base64)
    var myUrl = URL.createObjectURL(myBlob)
    downloadFile(myUrl, name)
  }
  // downloadFileByBase64('data:image/png;base64,iVBORw..........太长了.....')
  downloadFileByBase64(imgDataSrc)
}
